import { Routes, Route } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { PortalPage } from "@/PortalPage";

const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes);

export default function App() {
  return (
    <SentryRoutes>
      <Route path="/p/:token" element={<PortalPage />} />
      {/* Legacy URL shape from when portal lived under cockpit. Kept so old
          email links keep working until cockpit's redirect window closes. */}
      <Route path="/portal/:token" element={<PortalPage />} />
      {/* Anything else (incl. a tokenless `/p/`, which does NOT match
          `/p/:token`) renders PortalPage with no token → its ErrorScreen
          ("invalid/expired link"). Previously this was `<Navigate to="/p/">`,
          which looped against itself and rendered a blank page. */}
      <Route path="*" element={<PortalPage />} />
    </SentryRoutes>
  );
}
